module.exports = __webpack_public_path__ + "img/57_12.f23e2124.png";